interface Props {
  title: string;
  hint?: string;
}

export function EmptyState({ title, hint }: Props) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-6 text-center">
      <div className="mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-zinc-900 ring-1 ring-inset ring-zinc-800">
        <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-full bg-zinc-600" />
      </div>
      <div className="text-[13px] font-medium text-zinc-200">{title}</div>
      {hint ? (
        <div className="mt-1.5 max-w-sm text-[12px] leading-relaxed text-zinc-500">{hint}</div>
      ) : null}
    </div>
  );
}
